// src/i18n.ts
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";

i18n
    .use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: "en",
        supportedLngs: ["en"],
        ns: ["common"],
        defaultNS: "common",
        detection: {
            order: ["querystring", "localStorage", "cookie", "navigator"],
            caches: ["localStorage", "cookie"]
        },
        interpolation: { escapeValue: false },
        backend: {
            loadPath: "/locales/{{lng}}/{{ns}}.json"
        },
        react: { useSuspense: true }
    });

export { i18n };
